import { Stack, Title } from "@mantine/core";

export const SeoSection = ({
  title,
  children,
}: {
  title?: string;
  children: React.ReactNode;
}): JSX.Element => {
  return (
    <Stack spacing={0}>
      {!!title && (
        <Title color="dark.3" order={5}>
          {title}
        </Title>
      )}
      <Stack spacing="sm">{children}</Stack>
    </Stack>
  );
};
